import React, { useState } from 'react';
import { useAuth } from './context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [mensaje, setMensaje] = useState({ texto: '', tipo: '' });

    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensaje({ texto: '', tipo: '' });

        if (!email || !password) {
            setMensaje({ texto: '❌ Email y contraseña son obligatorios.', tipo: 'error' });
            return;
        }

        try {
            // --- MODIFICADO ---
            const response = await fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Error al iniciar sesión.');
            }
            login(data);
            
            navigate('/dashboard');

        } catch (error) {
            setMensaje({ texto: `❌ ${error.message}`, tipo: 'error' });
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <div className="card shadow p-4" style={{ width: '100%', maxWidth: '500px' }}>
                <h2 className="text-center mb-4">Iniciar Sesión</h2>
                {mensaje.texto && (
                    <div className={`alert ${mensaje.tipo === 'error' ? 'alert-danger' : 'alert-success'}`} role="alert">
                        {mensaje.texto}
                    </div>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control bg-light"
                            placeholder="Tu Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-control bg-light"
                            placeholder="Tu Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn w-100 text-white" style={{ backgroundColor: '#800020' }}>Iniciar Sesión</button>
                </form>

                <div className="d-flex justify-content-between mt-4">
                    {/* <Link to="/registro" style={{ color: '#800020' }}>¿Aún no tienes una cuenta?</Link> */}
                    <Link to="/solicitar-recuperacion" style={{ color: '#800020' }}>¿Olvidaste tu Password?</Link>
                </div>
            </div>
        </div>
    );
}

export default Login;